import { preRequisitesDocumentList } from "constants/preRequisitesDocument";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

//get the list of preRequisites document
export const getPreRequisitesDocList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_preRequisites_document_list(pageNum, filters);
    dispatch({ type: preRequisitesDocumentList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: preRequisitesDocumentList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

//add the preRequisites document
export const addPreRequisitesDoc = async (bodyData) => {
  try {
    const res = await api.add_preRequisites_document(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//update or edit the preRequisites document
export const editPreRequistesDoc = async (id, bodyData) => {
  try {
    const res = await api.edit_preRequisites_document(id, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
